<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('addministration.currency_feature.name_kh') }}
        </label>
        <input
          ref="currency_name_kh"
          v-model="model.currency_name_kh"
          type="text"
          class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('currency_name_kh') }"
          :placeholder="$t('addministration.currency_feature.enter_name_kh')"
        />
        <div class="invalid-feedback" v-if="errors.has('currency_name_kh')">
          {{ errors.first('currency_name_kh') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('addministration.currency_feature.name_en') }}
          <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.currency_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('currency_name_en') }"
          :placeholder="$t('addministration.currency_feature.enter_name_en')"
        />
        <div class="invalid-feedback" v-if="errors.has('currency_name_en')">
          {{ errors.first('currency_name_en') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('addministration.currency_feature.code') }}
          <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.currency_code"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('currency_code') }"
          :placeholder="$t('addministration.currency_feature.example_usd')"
        />
        <div class="invalid-feedback" v-if="errors.has('currency_code')">
          {{ errors.first('currency_code') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('addministration.currency_feature.sign') }}
          <span class="text-danger">*</span>
        </label>
        <input
          v-model="model.currency_sign"
          type="email"
          class="form-control"
          :class="{ 'is-invalid': errors.has('currency_sign') }"
          :placeholder="$t('addministration.currency_feature.example_$')"
        />
        <div class="invalid-feedback" v-if="errors.has('currency_sign')">
          {{ errors.first('currency_sign') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('addministration.currency_feature.cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('addministration.currency_feature.update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('addministration.currency_feature.save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'currency-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        currency_name_kh: '',
        currency_name_en: '',
        currency_code: '',
        currency_sign: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  mounted() {
    this.$refs.currency_name_kh.focus()
  },
  created() {
    this.setEdit()
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.errors = new Errors()
      this.$emit('success_update')
      this.$router.push({ name: 'currency' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('currency/create', this.model)
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.currency_name_kh.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch('currency/update', this.model)

        this.$toasted.success(response.message)
        this.$router.push({ name: 'currency' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.currency_name_kh.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return

      this.model = Object.assign({}, this.edit)
      this.errors = new Errors()
      this.editing = true
    },

    clearForm() {
      this.model.currency_name_kh = ''
      this.model.currency_name_en = ''
      this.model.currency_code = ''
      this.model.currency_sign = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
